export default __webpack_public_path__ + "static/media/check-icon.c136a9a9.svg";